import { CopyIconWithText } from "@/components/CopyIconWithText";
import { Icon } from "@/components/Icon";
import { orderStatusMap } from "@/constants/order/status";
import { Order } from "@/types/Api/Order";
import { UserInfo } from "@/types/Api/User/User/MyAccount/login";
import { amountFormat } from "@/utils/tool";
import { useCreation } from "ahooks";
import { Space } from "antd-mobile";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./index.module.scss";

type OrderItemProps = {
  order: Order;
  user: UserInfo;
  onClick?: () => void;
};

const isSale = (order: Order, user: UserInfo): boolean => {
  if (!user) return false;
  return order.sellerId === user.userId && order.sellerType === "Member";
};

const OrderTypeMap: Record<number, { text: string; type: string }> = {
  0: { text: "买", type: "buy" },
  1: { text: "卖", type: "sell" },
};

const OrderType = (props: { type: number }) => {
  const obj = useCreation(() => {
    return OrderTypeMap[props.type];
  }, [props.type]);
  return (
    <div className={classNames(styles.orderType, styles[obj.type])}>
      <div className={classNames(styles.orderTypeBg, styles[obj.type])} />
      <div className={classNames(styles.orderTypeText)}>{obj.text || ""}</div>
    </div>
  );
};

const defaultOrderStatus = { key: "unkown", text: "未知", color: "#FF4040" };

export const CryptoOrderItem = ({ order, user, onClick }: OrderItemProps) => {
  const status = useMemo(() => {
    return orderStatusMap[order.status] || defaultOrderStatus;
  }, [order]);
  return (
    <div className={styles.orderItem} onClick={onClick}>
      <div
        className={styles.orderStatus}
        style={{ backgroundColor: status.color }}
      >
        <div className={styles.orderStatusText}>{order.status}</div>
      </div>
      <div className={styles.orderItemInfo}>
        
        <div style={{fontSize: '14px', color:'#333', fontWeight: 600}} >{order.passageType}</div>
        <CopyIconWithText
          className={styles.orderNo}
          text={`订单编号:${order.orderNo}`}
        />
        <div className={styles.orderItemInfoDetail}>
          <div>
            <Space align="end">
              <div className={styles.orderAmount}>
                {amountFormat(order.amount)}{" "}
                <span style={{fontSize: '12px'}}>{order.paymentType}</span>
                {/* <Icon name={"vcoin"} size={"24px"} className={styles.icon} /> */}
              </div>
            </Space>

            <div className={styles.orderTime}>{order.createTime}</div>
          </div>

          <div className={styles.orderProcessButton}>查看进度</div>
        </div>
        {/* <OrderType type={isSale(order, user) ? 1 : 0} /> */}
      </div>
    </div>
  );
};
